import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { logo, title, description, linkText, link } = props;
	const logos = Array.isArray(logo) ? logo : [logo];

	return (
		<React.Fragment>
			<div className="project">
				<br />
				<Link to={link}>
					<div className="project-container">
						<div className="project-logo">
							{logos.map((logoSrc) => (
								<img key={logoSrc} src={logoSrc} alt="project logo" />
							))}
						</div>
						<div className="project-title">{title}</div>
						<div className="project-description">{description}</div>
						<br />
						<div className="project-link">
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faLink} />
							</div>

							<div className="project-link-text">{linkText}</div>
							<br /><br />
							<hr />
							<br />
						</div>
					</div>
				</Link>
			</div>
		</React.Fragment>
	);
};

export default Project;
